module.exports = __webpack_public_path__ + "img/cover.027f5f85.webp";